/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsfieldactivehint3Inputs */

const en_ticketsfieldactivehint3 = /** @type {(inputs: Ticketsfieldactivehint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When off, guests can no longer get this ticket type.`)
};

const de_ticketsfieldactivehint3 = /** @type {(inputs: Ticketsfieldactivehint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgeschaltet können Gäste diese Ticketart nicht mehr holen.`)
};

/**
* | output |
* | --- |
* | "When off, guests can no longer get this ticket type." |
*
* @param {Ticketsfieldactivehint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsfieldactivehint3 = /** @type {((inputs?: Ticketsfieldactivehint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsfieldactivehint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsfieldactivehint3(inputs)
	return de_ticketsfieldactivehint3(inputs)
});
export { ticketsfieldactivehint3 as "ticketsFieldActiveHint" }